function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
export const getExtremumX = params => {
  var _axis$data, _axis$data2;
  const axis = params.axis;
  const minX = Math.min(...((_axis$data = axis.data) !== null && _axis$data !== void 0 ? _axis$data : []));
  const maxX = Math.max(...((_axis$data2 = axis.data) !== null && _axis$data2 !== void 0 ? _axis$data2 : []));
  return [minX, maxX];
};
function getSeriesExtremums(getValues, stackedData, filter) {
  return stackedData.reduce((seriesAcc, stackedValue, index) => {
    const _getValues = getValues(stackedValue),
      _getValues2 = _slicedToArray(_getValues, 2),
      base = _getValues2[0],
      value = _getValues2[1];
    if (filter && (!filter({
      y: base,
      x: null
    }, index) || !filter({
      y: value,
      x: null
    }, index))) {
      return seriesAcc;
    }
    return [Math.min(base, value, seriesAcc[0]), Math.max(base, value, seriesAcc[1])];
  }, [Infinity, -Infinity]);
}
export const getExtremumY = params => {
  const series = params.series,
    axis = params.axis,
    isDefaultAxis = params.isDefaultAxis,
    getFilters = params.getFilters;
  return Object.keys(series).filter(seriesId => {
    var _series$seriesId$yAxi;
    const yAxisId = (_series$seriesId$yAxi = series[seriesId].yAxisId) !== null && _series$seriesId$yAxi !== void 0 ? _series$seriesId$yAxi : series[seriesId].yAxisKey;
    return yAxisId === axis.id || isDefaultAxis && yAxisId === undefined;
  }).reduce((acc, seriesId) => {
    var _series$seriesId$xAxi, _series$seriesId$yAxi2;
    const _series$seriesId = series[seriesId],
      area = _series$seriesId.area,
      stackedData = _series$seriesId.stackedData;
    const isArea = area !== undefined;
    const filter = getFilters === null || getFilters === void 0 ? void 0 : getFilters({
      currentAxisId: axis.id,
      isDefaultAxis,
      seriesXAxisId: (_series$seriesId$xAxi = series[seriesId].xAxisId) !== null && _series$seriesId$xAxi !== void 0 ? _series$seriesId$xAxi : series[seriesId].xAxisKey,
      seriesYAxisId: (_series$seriesId$yAxi2 = series[seriesId].yAxisId) !== null && _series$seriesId$yAxi2 !== void 0 ? _series$seriesId$yAxi2 : series[seriesId].yAxisKey
    });

    // Since this series is not used to display an area, we do not consider the base (the d[0]).
    const getValues = isArea && axis.scaleType !== 'log' && typeof series[seriesId].baseline !== 'string' ? d => d : d => [d[1], d[1]];
    const seriesExtremums = getSeriesExtremums(getValues, stackedData, filter);
    const _seriesExtremums = _slicedToArray(seriesExtremums, 2),
      seriesMin = _seriesExtremums[0],
      seriesMax = _seriesExtremums[1];
    return [Math.min(seriesMin, acc[0]), Math.max(seriesMax, acc[1])];
  }, [Infinity, -Infinity]);
};